import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-hk-tax",
  "use": "icon-soc-hk-tax-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-hk-tax\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<rect x=\"256\" y=\"160\" width=\"512\" height=\"704\" rx=\"24\" /><path d=\"M320 256h384v48H320zM320 352h384v48H320zM320 448h256v48H320z\" fill=\"#fff\" /><path d=\"M640 640h96v160H640z\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-hk-tax.svg
// module id = voSn
// module chunks = 546